import config from '@/config';

export const ONE_HOUR_TO_MILLISECONDS = 3600000;
export const SELLING_METHOD = {
  fixPrice: 1,
  dutchAuction: 2
};

export const SELLING_METHOD_TEXT = {
  fixedPrice: 'fixed_price',
  dutchAuction: 'dutch_auction',
  auction: 'auction'
};

export const MARKET_ADDRESSES = {
  bunicornMarketplace: config.projects.bunicornGame.marketplaceAddress,
  nftMarketplace: config.addresses.marketplaceAddress,
  dutchAuctionMarketplace: config.addresses.bunicornNFTAuctionMarketplace
};
